<template>
  <div>
    <el-form ref="forms" label-width="100px" class="forms-lines">
      <el-form-item label="商品描述">
        <tinymce ref="editor" v-model="content"
          toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="submit">立即提交</el-button>
        <el-button type="primary" size="small">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import tinymce from '@/components/common/tinymce.vue';
  export default {
    components: {
      tinymce
    },
    data() {
      return {
        content: '',
      }
    },
    computed: {
      ...mapState({
        user: state => state.user.user,
      })
    },
    mounted() {

    },
    methods: {
      submit(){
        
      }
    } 
  }
</script>

<style>

</style>